<template>
  <v-main class="main">
    <v-app-bar app flat color="white">
      <v-toolbar-title class="font-weight-bold">艺爪付费</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" outlined :href="DocLink.HOME" target="_blank">文档</v-btn>
      <ProjectMenu v-if="isLogin"></ProjectMenu>
    </v-app-bar>
    <template v-if="currentProject">
      <v-container fluid class="action-container">
        <div class="card-wrapper">
          <v-card flat class="card" :to="projectLink">
            <v-card-title class="d-flex justify-space-between">
              <span>项目</span>
            </v-card-title>
          </v-card>
        </div>
        <div class="card-wrapper">
          <v-card flat class="card" to="/dash/equity">
            <v-card-title class="d-flex justify-space-between">
              <span>权益</span>
            </v-card-title>
          </v-card>
        </div>
        <div class="card-wrapper">
          <v-card flat class="card" to="/dash/product">
            <v-card-title class="d-flex justify-space-between">
              <span>商品</span>
            </v-card-title>
          </v-card>
        </div>
        <div class="card-wrapper">
          <v-card flat class="card" to="/dash/payment-order">
            <v-card-title class="d-flex justify-space-between">
              <span>订单</span>
            </v-card-title>
          </v-card>
        </div>
        <div class="card-wrapper">
          <v-card flat class="card" to="/dash/customer">
            <v-card-title class="d-flex justify-space-between">
              <span>用户</span>
            </v-card-title>
          </v-card>
        </div>
        <div class="card-wrapper">
          <v-card flat class="card" to="/dash/payment-channel">
            <v-card-title class="d-flex justify-space-between">
              <span>支付渠道</span>
            </v-card-title>
          </v-card>
        </div>
        <div class="card-wrapper">
          <v-card flat class="card" to="/dash/price-table">
            <v-card-title class="d-flex justify-space-between">
              <span>价格表</span>
            </v-card-title>
          </v-card>
        </div>
        <div class="card-wrapper">
          <v-card flat class="card" to="/dash/redeem-code">
            <v-card-title class="d-flex justify-space-between">
              <span>兑换码</span>
            </v-card-title>
          </v-card>
        </div>
        <div class="card-wrapper">
          <v-card flat class="card" to="/dash/balance-task">
            <v-card-title class="d-flex justify-space-between">
              <span>数据导入</span>
            </v-card-title>
          </v-card>
        </div>
        <div class="card-wrapper">
          <v-card flat class="card" to="/dash/promoter-list">
            <v-card-title class="d-flex justify-space-between">
              <span>推广员</span>
            </v-card-title>
          </v-card>
        </div>
        <div class="card-wrapper">
          <v-card flat class="card" to="/dash/promoter-config">
            <v-card-title class="d-flex justify-space-between">
              <span>推广设置</span>
            </v-card-title>
          </v-card>
        </div>
        <div class="card-wrapper">
          <v-card flat class="card" to="/dash/promoter-payout">
            <v-card-title class="d-flex justify-space-between">
              <span>佣金提现</span>
            </v-card-title>
          </v-card>
        </div>
      </v-container>
    </template>
    <template v-else>
      <v-container fluid>
        <p class="no-project">请选择或创建项目</p>
      </v-container>
    </template>
  </v-main>
</template>

<script>
import ProjectMenu from '@/components/ProjectMenu.vue'
import { API } from '@/plugins/api'
import { mdiChevronRight } from '@mdi/js'
import { homeStore } from '@/store/home'
import { tokenStore } from '@/store/token'
import { merchantStore } from '@/store/merchant'
import { projectStore } from '@/store/project'
import _ from 'lodash'
import { DocLink } from '@/plugins/doc'

export default {
  name: 'MerchantPage',
  components: {
    ProjectMenu,
  },
  data() {
    return {
      mdiChevronRight,
      DocLink,
    }
  },
  computed: {
    isLogin() {
      return merchantStore.isLogin
    },
    currentProject() {
      return projectStore.current
    },
    projectLink() {
      let project_id = projectStore.currentId
      return _.isNil(project_id) ? null : `/dash/project-detail?id=${project_id}`
    },
  },
  async mounted() {
    let authCode = this.$route.query['code']
    if (authCode) {
      await this.onAuthCallback(authCode)
    }
    await homeStore.doLoad()
  },
  methods: {
    async onAuthCallback(code) {
      let result = await API.call('merchant/auth.create_token', { code: code })
      tokenStore.setToken({ token: result['token'] })
      merchantStore.setUser(result)
      this.$router.replace(this.$route.path)
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/styles/common';

.main {
  background-color: #f3f3f3;
}

.action-container {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  padding: 0 4px 8px 4px;
}

.card-wrapper {
  margin-top: 16px;
  width: 50%;
  padding-left: 8px;
  padding-right: 8px;

  &.fullwidth {
    width: 100%;
  }
}


.card {
  padding-left: 32px;

  &:hover {
    background-color: rgba(@antBlue, 0.2);
  }
}

.no-project {
  margin-top: 64px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #cccccc;
}
</style>
